import { FC, LegacyRef, ReactNode } from 'react';
import { styled } from '@mui/material';
import { useIntersection } from '../../hooks/useIntersection';
import { useAtomValue } from 'jotai';
import { isSmallScreenState } from '../../state/UIState';

const Td = styled('td')<{ width?: string; minWidth?: string; maxWidth?: string; isSmallDevice: boolean }>`
  width: ${({ width }) => (width ? width : 'auto')};
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth};` : '')}
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth};` : '')}
  text-align: left;
  padding: 0 16px 0 0;
  &:first-of-type {
    padding-left: ${({isSmallDevice}) => isSmallDevice ? '0px' : '16px'};
  }
  p {
    white-space: ${({isSmallDevice}) => isSmallDevice ? 'normal' : 'nowrap'};
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

interface IProps {
  children: ReactNode;
  colSpan?: number;
  style?: React.CSSProperties;
  width?: string;
  minWidth?: string;
  maxWidth?: string;
  disableLazyLoading?: boolean;
}

export const TableDataCell: FC<IProps> = ({
  colSpan,
  style,
  width,
  minWidth,
  maxWidth,
  disableLazyLoading = false,
  children,
}) => {
  const [isIntersecting, ref] = useIntersection();
  const isSmallDevice = useAtomValue(isSmallScreenState);

  return (
    <Td
      style={style}
      isSmallDevice={isSmallDevice}
      width={width}
      minWidth={minWidth}
      maxWidth={maxWidth}
      colSpan={colSpan}
      ref={ref as LegacyRef<HTMLTableDataCellElement>}
    >
      {(isIntersecting || disableLazyLoading) && children}
    </Td>
  );
};
